import {useEffect, useState} from "react";

export const usePollForBuildId = (interval = 60 * 1000) => {
  const [buildVersion, setBuildVersion] = useState(null);

  useEffect(() => {

    // Initial setup to fetch build version
    fetch("/package-meta.json")
      .then((response) => response.json())
      .then((data) => {
        setBuildVersion(data.v);
      })
      .catch((error) => console.error("Error fetching package data:", error));

  }, [buildVersion]);

  return {buildVersion};
};
